import React from 'react'

const HomeCards = () => {
    return ( 
        <div className="p-5">
            <div className="container">
                <div className="row tex-center">
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-dark text-light text-center ">
                            <div className="card-header py-3">
                                <h4 className="my-0 fw-normal">≤0.1Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:5000<small className="text-muted fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4 justify-content-between">
                                <li>10 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-outline-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-secondary text-center  text-white">
                            <div className="card-header py-3">
                                <h4 className="my-0 fw-normal">≤0.5Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:10,000<small className="fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4">
                                <li>5 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-dark text-white text-center">
                            <div className="card-header py-3 text-white">
                                <h4 className="my-0 fw-normal">≤1Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:20,000<small className="text-muted fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4">
                                <li>5 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access and SMS notification</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-dark text-white text-center">
                            <div className="card-header py-3">
                                <h4 className="my-0 fw-normal">≤5Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:30000<small className="text-muted fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4">
                                <li>10 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-outline-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-secondary text-white text-center">
                            <div className="card-header py-3">
                                <h4 className="my-0 fw-normal">≤15Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:45,000<small className="fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4">
                                <li>5 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="card mb-4 rounded-3 shadow-sm bg-dark text-white text-center">
                            <div className="card-header py-3 text-white">
                                <h4 className="my-0 fw-normal">≤20Kg</h4>
                            </div>
                            <div className="card-body">
                                <h3 className="card-title pricing-card-title">UGSH:60,000<small className="text-muted fw-light">/parcel</small></h3>
                                <ul className="list-unstyled mt-3 mb-4">
                                <li>5 parcels come with one free delivery</li>
                                <li>20 parcels come with two free delivery</li>
                                <li>And Email support to keep track of your deliveries</li>
                                <li>Help center access and SMS notification</li>
                                </ul>
                                <h4 className="w-100 btn btn-lg btn-primary">Best Quotes in town</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default HomeCards;